import React from 'react';
import InputSearch from '../../../../components/InputSearch';
import { Resources } from '../../../../models/ScheduleResource';
import { SearchResult } from '../SearchResult';
import { Results, ResultsWrapper } from './styles';
import { EmptyList } from '../EmptyList';

const arrowLeftIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow_left.svg';

export interface IOptionsList {
  id: string;
  name: string;
}

export type SearchProps = {
  changeContext: () => void;
  rounded: boolean;
  handleClickResult: (item: IOptionsList) => void;
  selectedService?: Resources;
  optionsList: IOptionsList[];
  filterInputSearch: string;
  handleChangeValue: (value: string) => void;
  handleClear: () => void;
  emptyListFirstButton: (() => void) | null;
  emptyListSecondButton: (() => void) | null;
};

const Search: React.FC<SearchProps> = ({
  handleClickResult,
  changeContext,
  rounded,
  selectedService,
  optionsList,
  filterInputSearch,
  handleChangeValue,
  handleClear,
  emptyListFirstButton,
  emptyListSecondButton
}) => {
  const scrollToItem = () => {
    const element = document.getElementById(`#item-result-${selectedService?.id}`);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  if (optionsList.length) scrollToItem();

  return (
    <>
      <InputSearch
        fullWidth={true}
        onChange={value => {}}
        placeholder="Pesquisar"
        rounded={rounded}
        value={filterInputSearch}
        handleChangeValue={handleChangeValue}
        iconLeft={
          <div
            style={{ marginRight: '16px' }}
            onClick={() => {
              changeContext();
              handleClear();
            }}
          >
            <img src={arrowLeftIcon} />
          </div>
        }
        autoFocus={true}
        handleClearIcon={() => {
          handleClear();
        }}
        clearIcon
      />
      <ResultsWrapper className="results-wrapper" standardSpacing={true}>
        <Results>
          <>
            {optionsList &&
              optionsList.map(item => {
                return <SearchResult key={item.id} title={item.name} onClick={() => handleClickResult(item)} />;
              })}
          </>
        </Results>
      </ResultsWrapper>
      <EmptyList
        emptyListFirstButton={emptyListFirstButton}
        emptyListSecondButton={emptyListSecondButton}
        visible={filterInputSearch.length > 0 && !optionsList.length}
        searchInputText={filterInputSearch}
      />
    </>
  );
};

export default Search;
